import { bookingInquiryApis } from '@apis/dashboard/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchBookingInquiryOwner = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (owner: number) => {
      const response = await bookingInquiryApis.patch(
        '/dashboard/booking-inquiry/{d2d_no}/owner/',
        {
          path: { d2d_no },
          body: { owner },
        },
      );

      if (response[400]) {
        throw new FormError('PatchBookinfInquiryOwner', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2d_no}/`]);
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2d_no}/owner/`]);
      },
    },
  );
};
